import { useCallback, useEffect, useMemo, useState } from "react";
import { useDebounce } from "@madmedical/utils";
import { getGenderChoices, getServiceChoices, getUnderlyingConditionChoices, } from "@madmedical/medical";
import adaptPatient from "./adaptPatient";
import { useGetPatientsQuery } from "./api";
export default (arg) => {
    var _a;
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [search, setSearch] = useState();
    const debouncedSearch = useDebounce(search, 300, () => {
        setPage(1);
    });
    const { data, isLoading } = useGetPatientsQuery(Object.assign(Object.assign({}, filter), { page }));
    const filterChoices = useMemo(() => {
        var _a, _b;
        return ({
            services: getServiceChoices(filter.services),
            genders: getGenderChoices(filter.gender),
            underlyingConditions: getUnderlyingConditionChoices(filter.underlyingConditions),
            deviceTypes: (_b = (_a = arg === null || arg === void 0 ? void 0 : arg.deviceTypes) === null || _a === void 0 ? void 0 : _a.map(({ id, name, manufacturer }) => {
                var _a;
                return ({
                    key: id,
                    text: `${manufacturer.forHumans} ${name}`,
                    isSelected: !!((_a = filter.deviceTypeIds) === null || _a === void 0 ? void 0 : _a.includes(id)),
                });
            })) !== null && _b !== void 0 ? _b : [],
        });
    }, [filter, arg === null || arg === void 0 ? void 0 : arg.deviceTypes]);
    const handleFilterChange = useCallback((key, selected) => {
        setPage(1);
        // TODO: Why does type inference fail me?
        const diff = key === "services"
            ? { services: selected }
            : key === "genders"
                ? { gender: selected[0] }
                : key === "underlyingConditions"
                    ? { underlyingConditions: selected }
                    : key === "deviceTypes"
                        ? { deviceTypeIds: selected }
                        : {};
        setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), diff)));
    }, []);
    const handleSearchChange = (search) => {
        setSearch(search);
    };
    useEffect(() => {
        setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), { search: debouncedSearch })));
    }, [debouncedSearch]);
    const handleSortChange = useCallback((sort, order) => {
        setPage(1);
        if (!sort) {
            setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), { sort: undefined, order: undefined })));
            return;
        }
        setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), { sort: sort, // TODO: Better types
            order })));
    }, []);
    const handleEndReached = useCallback(() => {
        if (!data) {
            return;
        }
        const { currentPage, pageCount } = data.pagination;
        if (currentPage >= pageCount) {
            return;
        }
        setPage(currentPage + 1);
    }, [data]);
    return {
        isLoading,
        patients: (_a = data === null || data === void 0 ? void 0 : data.items) === null || _a === void 0 ? void 0 : _a.map((adaptPatient)),
        pagination: data === null || data === void 0 ? void 0 : data.pagination,
        handleSortChange,
        handleSearchChange,
        filterChoices,
        handleFilterChange,
        handleEndReached,
    };
};
